import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { Table } from '@ipc/ipc-components';

import AlertDialog from '../../AlertDialog';
import { HISTORY_TABLE_COLUMNS } from '../constants';
import { getReceptacleActionHistoryList } from '../../../../api';

const ActionHistoryModal = ({ onDismiss, data }) => {
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (data) {
      setLoading(true);
      getReceptacleActionHistoryList({ receptacleSnapshotId: data })
        .then((response) => {
          setHistoryData(response || []);
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching action history:', error);
          setLoading(false);
        });
    }
  }, [data]);

  return (
    <AlertDialog
      open={!!data}
      title="Action History"
      onDismiss={onDismiss}
      isLargeModal
    >
      <div className="Form">
        <Table
          columns={HISTORY_TABLE_COLUMNS}
          data={historyData}
          loading={loading}
          minRows={0}
        />
      </div>
    </AlertDialog>
  );
};

ActionHistoryModal.propTypes = {
  onDismiss: PropTypes.func,
  data: PropTypes.string,
};

export default ActionHistoryModal;
